
import { useState } from "react";
import moment from "moment";
import FiltersPanel from "components/shared/TableWithFilters/FiltersPanel";
import { FilterLabel } from "components/shared/TableWithFilters/styles.tableWithFilters";
import FilterMultiSelect from "components/shared/TableWithFilters/FilterMultiSelect";
import Datepicker from "components/shared/Datepicker/Datepicker";
import FilterDateTrigger from "components/core/PO/PurchaseOrderList/FilterDateTrigger";
import { FilterFieldFixed } from "components/core/GRN/styles.grnDesktop";

export default function PayoutFilters({
  draftFilters,
  onDueDateChange,
  onStatusChange,
  statusOptions,
  onApply,
  onClear,
  applyDisabled = false,
}) {
  const [dueDatePickerOpen, setDueDatePickerOpen] = useState(false);

  const mappedStatusOptions = statusOptions.map((option) => ({
    value: option.key,
    label: option.label,
  }));

  const selectedStatuses = Array.isArray(draftFilters.status) ? draftFilters.status : [];

  return (
    <FiltersPanel onApply={onApply} onClear={onClear} applyDisabled={applyDisabled}>
      <FilterFieldFixed>
        <FilterLabel>Due on</FilterLabel>
        <Datepicker
          selected={draftFilters.dueDate ? new Date(draftFilters.dueDate) : null}
          onChange={(date) => {
            onDueDateChange(date);
            setDueDatePickerOpen(false);
          }}
          open={dueDatePickerOpen}
          onInputClick={() => setDueDatePickerOpen(true)}
          onClickOutside={() => setDueDatePickerOpen(false)}
          customInput={
            <FilterDateTrigger
              value={draftFilters.dueDate ? moment(draftFilters.dueDate).format("DD MMM 'YY") : ""}
            />
          }
        />
      </FilterFieldFixed>
      <FilterFieldFixed>
        <FilterLabel>Status</FilterLabel>
        <FilterMultiSelect
          options={mappedStatusOptions}
          selected={selectedStatuses}
          onToggle={onStatusChange}
          placeholder="Select payment status"
        />
      </FilterFieldFixed>
    </FiltersPanel>
  );
}
